<template>
  <SOSlotBase
      container-name="container-input-scan"
      :loading="loading"
  >
    <template v-slot:content>
      <SOTitleBar
          page-title="Scan QR Serial Number"
          type="close"
          :transparent="false"
          @back="back"
      />
      <SOInputScan
          @decode="toTambah"
      />
    </template>
    <template v-slot:loading-page>
      <SOLoadingPage v-if="loading"/>
    </template>
  </SOSlotBase>
</template>

<script>
import SOInputScan from "@/so-components/global/input/SOInputScan";
import SOModalInputManual from "@/so-components/global/modal/SOModalInputManual";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import {mapGetters} from "vuex";

export default {
  name: "SnapMesinScanSerial",
  components: {SOLoadingPage, SOTitleBar, SOSlotBase, SOModalInputManual, SOInputScan},
  data() {
    return {
      loading: true
    }
  },
  methods: {
    async toTambah(result) {
      this.input.serial = result
      this.$toast.success("Scan serial berhasil")
      await this.$router.push({
        name: "SnapMesinTambah",
        params: {
          idoutlet: this.$route.params.idoutlet,
        },
      })
    },

    back() {
      this.$router.push({
        name: "SnapMesinTambah",
        query: {
          idoutlet: this.$route.params.idoutlet
        }
      })
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 2000)
  },
  computed: {
    ...mapGetters("snapMesinModule", {
      input: "getDataCreateMesin"
    })
  }
}
</script>

<style scoped>

</style>